import { Pipe, PipeTransform } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { MxDatasource } from '../domains/common/interfaces';

@Pipe({
 standalone: false,
  name: 'mxEnumAsArray',
})
export class MxEnumAsArrayPipe implements PipeTransform {
  constructor(private i18nextPipe: I18NextPipe) {}
  transform(
    type: any,
    typeAsString: string,
    operationValues: {
      value: number;
      disabled: boolean;
      visible: boolean;
    }[] = []
  ): MxDatasource[] {
    return Object.keys(type)
      .filter((f) => !isNaN(+f))
      .filter((f) => {
        const opValue = operationValues.find(
          (x) => x.value.toString() === f.toString()
        );
        if (opValue) {
          if (opValue.visible) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
      .map((m) => {
        let disabled: boolean;
        const opValue = operationValues.find(
          (x) => x.value.toString() === m.toString()
        );
        disabled = opValue?.disabled;

        return {
          value: +m,
          label: this.i18nextPipe.transform(`enum:${typeAsString}.${type[m]}`),
          disabled: disabled,
        };
      });
  }
}

